import { Action } from "@ngrx/store";
import { BaseObject } from "../../business-objects/base-object/base-object.model";
import { BaseObjectFilters } from "../../../vas/store/bootstrap";
import { isDefined } from "ionic-angular/util/util";
import { ChangeQItem } from "../../services/sync-up/item";

export interface ActionOptionsArgs {
    restful?: boolean;
    persistable?: boolean;
}

export type ActionPayloadType = BaseObject | BaseObjectFilters | string | object | number | boolean;
export type SynchronisableActionPayloadType = BaseObject;

export const isRestfulAction = (x: any): x is SynchronisableAction => {
    return (x as BaseAction).options ? (x as BaseAction).options.restful : false;
};

export const isPersistableAction = (x: any): x is PersistableAction => {
    return (x as BaseAction).options ? (x as BaseAction).options.persistable : false;
};

export class ActionOptions {
    readonly restful: boolean;
    readonly persistable: boolean;

    constructor(args: ActionOptionsArgs) {
        this.restful = (args && isDefined(args.restful)) ? args.restful : true;
        this.persistable = (args && isDefined(args.persistable)) ? args.persistable : true;
    }
}

export abstract class BaseAction implements Action {
    readonly entity: string;
    readonly type: string;
    options: ActionOptionsArgs;

    constructor(public payload: ActionPayloadType, options?: ActionOptionsArgs) {
        this.options = new ActionOptions(options);
    }
}

export class NullAction extends BaseAction implements Action {
    readonly type: undefined;

    constructor() {
        super(undefined);
    }
}

export abstract class BaseObjectAction implements Action {
    readonly entity: string;
    readonly type: string;
    options: ActionOptionsArgs;

    constructor(public payload: ActionPayloadType, options?: ActionOptionsArgs) {
        this.options = new ActionOptions(options);
    }
}

export abstract class PersistableAction extends BaseObjectAction {

    constructor(public payload: ActionPayloadType, options?: ActionOptionsArgs) {
        super(payload, {persistable: true, ...options});
    }

    abstract getKey(): string;
}

export abstract class SynchronisableAction extends PersistableAction {

    changeQItem: ChangeQItem;
    changeQItems: Array<ChangeQItem>;

    constructor(public payload: BaseObject, options?: ActionOptionsArgs) {
        super(payload, {restful: true, ...options});
    }

    abstract getKey(): string;
}



// WEBPACK FOOTER //
// ./src/core/store/actions/base-actions.ts